const spreadsheetType = {
  BILLET: 'BOLETO',
  TRANSFER: 'TRANSFERENCIA',
  TRANSFER_WITH_PIX_KEY: 'TRANSFERENCIA_COM_CHAVE_PIX'
};

module.exports = spreadsheetType;
